import { PillsButtons } from '@quicktools/shared-components';
import { IPills } from '@quicktools/shared-components/components/core/PillsButtons/types';

import useStyles from './styles';
import ITogglesProps from './types';

const variants: IPills[] = [
  {
    text: 'Apple',
    value: 'apple',
  },
  {
    text: 'Google',
    value: 'google',
  },
  {
    text: 'Microsoft',
    value: 'microsoft',
  },
  {
    text: 'Samsung',
    value: 'samsung',
  },
];

function DeviceFilter({ heading, changeType, selected }: ITogglesProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      {heading && <div className={styles.heading}>{heading}</div>}
      <PillsButtons pills={variants} onSelectItem={changeType} selected={selected} />
    </div>
  );
}

export default DeviceFilter;
